import { Component, ElementRef, ChangeDetectorRef, HostListener, TemplateRef, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faEllipsisV, faEarthAsia, faSearch, faBars, faEdit, faL } from '@fortawesome/free-solid-svg-icons';
import { UserGroupService } from 'src/app/core/services/user-group/user-group.service';
import { AdminAccessService } from 'src/app/core/services/admin/admin-access/admin-access.service';
import { catchError } from 'rxjs/operators';
import { of, filter, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
import { PopoverDirective } from 'ngx-bootstrap/popover';

@Component({
    selector: 'app-admin-access',
    templateUrl: './admin-access.component.html',
    styleUrls: ['./admin-access.component.scss'],
})
export class AdminAccessComponent {
    searchText = '';
    accessnameText = '';
    descriptionText = '';
    labelText = '';
    showDropdown = false;
    highlighted: string = '';
    faEllipsisV = faEllipsisV;
    currentPage: number = 1; // Current page
    itemsPerPage = 10; // Items per page
    totalItems: any; // Total items
    totalPages: any; // Total pages
    clients: any;
    pageNumber = {
        page: 1,
    };
    disableForm = true;
    filteredClients = []; // Clients filtered based on search

    filteredClientsForm = [];
    searchTerm: string = ''; // For two-way binding with search bar

    isDropdownOpen: boolean = false; // Controls dropdown visibility
    searchIdsForUserGroupData: any;
    // selectedClient: string | null = null; // Selected clientselectedClients: string[] = []; // List of selected clients
    // selectedClient: string = ''; // Selected client
    selectedClient: string | null = null; // Stores the selected client
    selectedAccess: string | null = null;
    clientsList = [];
    userGroupList: any;
    accessList: any;
    // showDropdown: boolean = false; // Dropdown visibility
    showcreateandEditForm = false;
    clientList = ['Test Client 1', 'Test Client 2', 'Client Alpha', 'Client Beta', 'Client Gamma']; // Client list
    userGroups: any;
    assignedUserGroups: Record<number, boolean> = {};
    roles: any;
    // accessOptions = ['Access1', 'Access2', 'Access3', 'Access4'];
    pageSize = 5;
    searchListArray: any;
    userGroupForm: any;
    options: any;
    // options = ['Option 1', 'Option 2', 'Option 3', 'Option 4'];
    selectedOptions: any;

    multifilteredClients: any;
    multiclients: any;
    multisearchTerm: string = '';
    multiisDropdownOpen: boolean = false;
    multiselectedClient: string = '';
    // multiselectedClients :any[] = [];
    // multiselectedClients :any; // Properly typed and initialized
    multiselectedClients: any = []; // Properly typed and initialized
    keepDropdownOpen: boolean = false; // Prevent dropdown from closing on interaction
    selectedRole = '';
    selectedIds: any;
    disableSubmit = false;
    usergroupId: any;
    accessId: any;
    isMobile = false;

    selectedClientCountText = '#count# Client(s) Selected';
    selectedUserGroupCountText = '#count# User Groups Selected';
    selectedUserGroupBlankText = 'Select';
    selectedClientBlankText = 'Select';
    activeAccessList: number | null = null;
    activeAccessDesc: number | null = null;

    originalUserGroups: Record<number, boolean> = {};
    //private createUserGroupForClient: Subscription;
    isLoadingData = true;
    errors: { [key: string]: string } = {};
    @ViewChildren(PopoverDirective) popovers!: QueryList<PopoverDirective>; // Reference to all popovers

    @HostListener('window:focusin', ['$event'])
    onFocused(event: FocusEvent): void {
        document.body.style.position = '';
        document.body.style.top = '';
    }

    clearSearch() {
        this.searchText = ''; // Clear the search input
        this.assignedUserGroups = {};
        this.SearchList();
    }

    onSearchTextChange() {
        if (this.searchText == '') {
            //this.callandRefreshAccess();
            this.SearchList();
        }
    }

    activePopupIndex: number | null = null;
    toggleList(index: number, event: Event) {
        event.stopPropagation();
        if (this.activeAccessList === index) {
            // Close the "Access" popup
            this.activeAccessList = null;
        } else {
            if (this.activeAccessList !== null) {
                this.popovers.toArray()[this.activeAccessList].hide();
            } else if (this.activeAccessDesc !== null) {
                this.popovers.toArray()[this.activeAccessDesc].hide();
            }
            // Open the "Access" popup and close the "Actions" popup
            this.activeAccessList = index;
            this.activePopupIndex = null;
            this.activeAccessDesc = null;
        }
    }

    toggleDescription(index: number, event: Event, popover: PopoverDirective) {
        event.stopPropagation();
        if (this.activeAccessDesc === index) {
            // Close the "Access" popup;
            popover.hide();
            this.activeAccessDesc = null;
        } else {
            if (this.activeAccessDesc !== null) {
                this.popovers.toArray()[this.activeAccessDesc].hide();
            } else if (this.activeAccessList !== null) {
                this.popovers.toArray()[this.activeAccessList].hide();
            }

            popover.show();
            this.activeAccessDesc = index;
            this.activePopupIndex = null;
            this.activeAccessList = null;
        }
    }

    // Toggles the "Actions" popup
    togglePopup(index: number, event: Event): void {
        event.stopPropagation();
        if (this.activePopupIndex === index) {
            // Close the "Actions" popup
            this.activePopupIndex = null;
        } else {
            if (this.activeAccessDesc !== null) {
                this.popovers.toArray()[this.activeAccessDesc].hide();
            }
            // Open the "Actions" popup and close the "Access" popup
            this.activePopupIndex = index;
            this.activeAccessList = null;
            this.activeAccessDesc = null;
        }
    }

    // Close all popups when clicking outside
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        this.activePopupIndex = null;
        this.activeAccessList = null;
        //this.activeAccessDesc = null
        if (this.activeAccessDesc !== null) {
            this.popovers.toArray()[this.activeAccessDesc].hide();
        }

        // if (this.activeAccessList !== null) {
        //     this.popovers.toArray()[this.activeAccessList].hide();
        // }
    }

    restrictInput(event: KeyboardEvent): void {
        const allowedCharacters = /^[a-zA-Z0-9-_ ]*$/;
        const inputChar = event.key;

        if (!allowedCharacters.test(inputChar)) {
            event.preventDefault(); // Block the keypress
        }
    }

    editAccess(access: any, modal: TemplateRef<any>) {
        this.modalService.open(modal, { size: 'sm', windowClass: 'custom-modal-class-userGroup', backdrop: 'static', keyboard: false });
        this.disableForm = true;
        this.assignedUserGroups = {};
        this.accessId = access.id;
        console.log('Edited item is', access);
        this.showcreateandEditForm = true;
        this.accessnameText = access.accessName;
        this.validateField('accessnameText');
        this.descriptionText = access.description;
        this.labelText = access.accessLable;
        this.validateField('labelText');

        console.log('userGroupList', this.userGroupList);
        console.log('access item', access);

        const matchedItems = this.userGroupList?.filter((item: any) => access.userGroupLables.includes(item.label));

        console.log('Matched Items:', matchedItems);
        this.selectedUserGroupItems = matchedItems;
        // this.originalUserGroups = matchedItems;
        console.log('selectedUserGroupItems:', this.selectedUserGroupItems);
        this.selectedUserGroupItems.forEach((element: { isSelected: boolean }) => {
            element.isSelected = true;
        });

        //console.log('Updated assignedUserGroups:', this.assignedUserGroups);
        matchedItems.forEach((item: any) => {
            this.assignedUserGroups[item.userGroupId] = true; // Dynamically add key-value pairs
        });

        console.log('assignedUserGroups', this.assignedUserGroups);
    }

    deleteAccesss() {
        console.log('Delete:');
        // Add your delete logic here
    }
    // filteredClients:any;
    constructor(
        private fb: FormBuilder,
        private cd: ChangeDetectorRef,
        private usergroup: UserGroupService,
        private adminAccessService: AdminAccessService,
        private toast: ToastrService,
        private eRef: ElementRef,
        private modalService: NgbModal,
        private route: ActivatedRoute,
        private router: Router,
        private commonservice: CommonServiceService,
    ) {
        // this.createUserGroupForClient = this.commonservice.createUserGroupForClient$.subscribe((data) => {
        //     if (data?.createnew) {
        //         console.log('the value for createUserGroupForClient is', data.data.name);
        //         setTimeout(() => {
        //             this.createButton?.nativeElement?.click();
        //             this.selectedClient = data.data.name;
        //             this.searchTerm = data.data.name; // Show the selected value in the input
        //         }, 0); //
        //     }
        // });
    }

    @ViewChild('createButton', { static: true }) createButton!: ElementRef<HTMLButtonElement>;
    createnew: boolean | null = null;
    ngOnInit() {
        this.checkWidth();
        this.SearchList();
        this.userGroupsList();
        // this.usergroup.usergroupType().subscribe((data) => {
        //     this.roles = data;
        //     console.log('the result of usergroupType are', data);
        // });
    }

    checkWidth() {
        const width = window.innerWidth;
        console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    userGroupsList() {
        const req = {
            query: '',
            limit: null,
            offset: 0,
            order: 'ASC',
            sortBy: 'UserGroupId',
        };
        this.usergroup.displayUsergroupList(req).subscribe((data: any) => {
            console.log('data', data.userGroups);
            this.userGroupList = data.userGroups || [];
            console.log('user group ====', this.userGroupList);
        });
    }

    onChangeUserGroup(selectedValue: string) {
        const reqBody = {
            userGroupId: null,
            query: null,
            userGroupType: selectedValue,
            limit: null,
            offset: 0,
        };
        this.usergroup.getAccessList(reqBody).subscribe((data) => {
            console.log('the response of usergroup access is', JSON.stringify(data.accessList));
            this.options = data.accessList;
            this.selectedUserGroupItems = this.options.filter((item: { isSelected: any }) => item.isSelected);
            this.selectedOptions = this.options.filter((option: { isSelected: any }) => option.isSelected);
            this.selectedIds = this.selectedUserGroupItems.map((option: { id: any }) => option.id);
            this.validateField('selectedUserGroupItems');
        });
        console.log('this.userGroupForm.value', this.accessnameText, this.descriptionText, this.selectedClient, selectedValue);
    }

    blurDropdown(event: FocusEvent): void {
        setTimeout(() => {
            if (!(event.relatedTarget as HTMLElement)?.classList.contains('dropdown-item')) {
                this.showDropdown = false;
            }
        }, 150); // Allow dropdown interaction
    }

    get paginatedGroups() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.userGroups.slice(start, end);
    }

    onAction(group: any) {
        console.log('Action clicked for:', group);
    }

    // Handle dropdown change event
    onClientChange(event: Event): void {
        const selectedValue: string = (event.target as HTMLSelectElement).value;
        console.log('Selected Client:', selectedValue);
    }

    onSelect(searchStr: string) {
        console.log('the selected string is', searchStr);
    }
    onFocus() {
        this.showDropdown = true;
    }

    // Get start and end item indices for the current page
    get startItem(): number {
        return (this.currentPage - 1) * this.itemsPerPage + 1;
    }

    get endItem(): number {
        const endItem = this.currentPage * this.itemsPerPage;
        return endItem > this.totalItems ? this.totalItems : endItem;
    }

    // Navigate to the previous page
    prevPage(): void {
        if (this.currentPage > 1) {
            this.currentPage--;
        }
    }

    // Navigate to the next page
    nextPage(): void {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
        }
    }

    checkvalidation() {}

    openAccessCreationForm(modal: TemplateRef<any>) {
        this.modalService.open(modal, { size: 'sm', windowClass: 'custom-modal-class-userGroup', backdrop: 'static', keyboard: false });
        this.errors = {};
        this.accessnameText = '';
        this.descriptionText = '';
        this.labelText = '';
        //this.selectedRole = '';
        this.selectedIds = [];
        this.selectedOptions = [];
        this.selectedUserGroupItems = [];
        this.assignedUserGroups = {};
        this.disableForm = false;
        this.selectedAccess = '';
        this.searchTerm = '';
        console.log('the form is opened');
        this.showcreateandEditForm = true;
        //this.filterClients();
    }

    closeCreateandEditForm() {
        this.showcreateandEditForm = false;
        this.modalService.dismissAll();
    }

    onSubmit(): void {
        if (this.userGroupForm.valid) {
            console.log('Form Data:', this.userGroupForm.value);
        }
    }

    handleBlur() {
        setTimeout(() => {
            if (!this.keepDropdownOpen) {
                this.multiisDropdownOpen = false;
            }
            this.keepDropdownOpen = false;
        }, 200); // Delay to allow checkbox click to register
    }

    createNewAccess() {
        const request: any = {
            name: this.accessnameText.trim(),
            label: this.labelText.trim(),
            description: this.descriptionText?.trim() || '',
            assignedUserGroups: this.assignedUserGroups,
        };

        if (this.disableForm) {
            request.id = this.accessId;
        }

        const apiCall = !this.disableForm ? this.adminAccessService.createAccess(request) : this.adminAccessService.updateAccess(request);

        apiCall
            .pipe(
                catchError((error) => {
                    if ([400, 500].includes(error.status)) {
                        console.error('Server error occurred:', error.error.message);
                        this.toast.warning(error.error.message);
                    } else {
                        console.error('An error occurred:', error);
                    }
                    return of(null);
                }),
            )
            .subscribe((data) => {
                if (data) {
                    this.toast.success(data.message);
                    this.showcreateandEditForm = false;
                    this.modalService.dismissAll();
                    this.callandRefreshAccess();
                }
            });
    }

    callandRefreshAccess() {
        console.log('this is called first - 2');
        // this.pageNumber = {
        //     page: 1,
        // };
        //this.currentPage = 1;
        const offset = (this.pageNumber.page - 1) * this.itemsPerPage;
        const limit = this.pageNumber.page === this.totalPages ? this.totalItems - offset : this.itemsPerPage;
        console.log('called here');
        const reqBody = {
            // clientIds: this.searchIdsForUserGroupData,
            searchStr: this.searchText,
            limit: limit,
            offset: offset,
            // order: 'DESC',
            // sortBy: '',
        };
        this.adminAccessService.getAccessList(reqBody).subscribe((response) => {
            console.log('called here API getAccessList', response.data);
            this.totalItems = response.data.totalCount;
            this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
            this.accessList = response.data == null ? [] : response.data?.access;
            console.log('access list', this.accessList);

            // this.accessList.forEach((group: { accessNames: any; accessList: any }) => {
            //     if (group.accessList.length > 0) group.accessNames = group.accessList.map((access: { label: any }) => access.label).join(', ');
            //     else group.accessNames = 'No access found';
            //     group.accessList = group.accessList;
            // });
        });
    }

    selectedClientItems: Array<any> = [];
    onSelectionClientChange(selectedItems: Array<any>) {
        this.selectedClientItems = selectedItems;

        // Extract IDs of selected items
        const selectedIds = selectedItems.map((item) => item.id);
        console.log('Selected Client IDs:', selectedIds);
        this.searchIdsForUserGroupData = selectedIds;
        if (this.searchIdsForUserGroupData.length == 0) this.callandRefreshAccess();
        else this.SearchList();
    }

    selectedUserGroupItems: any;
    onSelectionUserGroupChange(selectedItems: Array<any>) {
        console.log('selectedItems', selectedItems);

        // Extract the IDs of the currently selected items
        const selectedIds = selectedItems.map((item) => item.userGroupId);

        // Remove deselected items from assignedUserGroups
        if (this.disableForm) {
            Object.keys(this.assignedUserGroups).forEach((userGroupId: any) => {
                // If the userGroupId was true but is no longer selected, mark it as false
                if (!selectedIds.includes(userGroupId)) {
                    this.assignedUserGroups[userGroupId] = false;
                }
            });
        } else {
            Object.keys(this.assignedUserGroups).forEach((userGroupId: any) => {
                if (!selectedIds.includes(userGroupId)) {
                    delete this.assignedUserGroups[userGroupId]; // Remove deselected items
                }
            });
        }

        // Add or update newly selected items as true
        selectedIds.forEach((userGroupId) => {
            this.assignedUserGroups[userGroupId] = true;
        });

        console.log('Updated assignedUserGroups:', this.assignedUserGroups);

        // Update selectedUserGroupItems
        this.selectedUserGroupItems = selectedItems.map((item) => ({
            ...item,
            isSelected: true,
        }));

        console.log('selectedUserGroupItems:', this.selectedUserGroupItems);
        this.validateField('selectedUserGroupItems');
    }

    onBlurUsergroup(isvalid: boolean) {
        if (isvalid) {
            this.validateField('selectedUserGroupItems');
        }
    }

    SearchList() {
        this.currentPage = 1;
        const offset = (this.pageNumber.page - 1) * this.itemsPerPage;
        const limit = this.pageNumber.page === this.totalPages ? this.totalItems - offset : this.itemsPerPage;

        const reqBody = {
            searchStr: this.searchText,
            limit: 10,
            offset: 0,
            //order: 'DESC',
            //sortBy: 'id',
        };

        this.adminAccessService.getAccessList(reqBody).subscribe((response) => {
            console.log(response.data);
            this.isLoadingData = false;
            this.totalItems = response.data?.totalCount;
            this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
            this.accessList = response.data == null ? [] : response.data?.access;
            console.log('totalItems', this.totalItems);
            console.log('totalPages', this.totalPages);
            console.log('access list', this.accessList);
            // this.searchText = '';
            // this.userGroups.forEach((group: { accessNames: any; accessList: any }) => {
            //     if (group.accessList.length > 0) group.accessNames = group.accessList.map((access: { label: any }) => access.label).join(', ');
            //     else group.accessNames = 'No access found';
            //     // group.accessNames = group.accessList.map((access: { label: any }) => access.label).join(', ');
            // });
            // console.log('the displayUsergroupList result is', this.userGroups);
        });
    }

    onPageChanged(event: any) {
        console.log('this is called first - 1');
        this.pageNumber = event;
        const offset = (this.pageNumber.page - 1) * this.itemsPerPage;
        const limit = this.pageNumber.page === this.totalPages ? this.totalItems - offset : this.itemsPerPage;
        const reqBody = {
            // clientIds: [],
            searchStr: this.searchText,
            limit: limit,
            offset: offset,
            //order: 'DESC',
            //sortBy: 'UserGroupId',
        };
        this.adminAccessService.getAccessList(reqBody).subscribe((response) => {
            this.accessList = response.data == null ? [] : response.data?.access;
            // this.userGroups.forEach((group: { accessNames: any; accessList: any }) => {
            //     // group.accessNames = group.accessList.map((access: { label: any }) => access.label).join(', ');
            //     if (group.accessList.length > 0) group.accessNames = group.accessList.map((access: { label: any }) => access.label).join(', ');
            //     else group.accessNames = 'No access found';
            // });
        });

        console.log('the page number is', this.pageNumber);
    }

    searchAccess() {
        if (this.searchText != '') this.SearchList();
    }

    isFormValid() {
        const userGroupnamePattern = /[a-zA-Z0-9]/;
        return (
            this.accessnameText?.trim() && // Check if User Group Name is not empty
            userGroupnamePattern.test(this.accessnameText) &&
            this.labelText?.trim() &&
            this.selectedUserGroupItems.length > 0 // Check if at least one Access option is selected
        );
    }

    validateField(field: string) {
        switch (field) {
            case 'accessnameText':
                this.errors[field] = this.accessnameText.trim() === '' ? 'Access Name is required' : '';
                break;
            case 'labelText':
                this.errors[field] = this.labelText.trim() === '' ? 'Label is required' : '';
                break;
            case 'selectedUserGroupItems':
                this.errors[field] = this.selectedUserGroupItems.length === 0 ? 'User Group is required' : '';
                break;
        }
    }
}
